import { createSelector } from '@reduxjs/toolkit';
import selectWishlistPageActions from '@spa/lib/store/wishlists/selectors/selectWishlistPageActions';

const selectFailedCreateMyWishlistActionIds = createSelector(
  [selectWishlistPageActions],
  (wishlistsPageActions): ReadonlyArray<number> =>
    wishlistsPageActions.createMyWishlist.failed.map((action): number => action.requestedActionId)
);

export default selectFailedCreateMyWishlistActionIds;
